import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Button, TextField, IconButton, Dialog, DialogTitle } from '@material-ui/core';
import { Close } from '@material-ui/icons';

import { TruckingCompany } from '../../../models/OfflineRfs';
import RfsStyles from '../rfs.module.css';
import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>
  createStyles({
    wrapper2: {
      width: '100%',
      display: 'flex',
      marginTop: '20px',
      marginBottom: '0',
      justifyContent: 'space-between',
      maxWidth: '1300px',
      marginRight: 'auto',
      marginLeft: 'auto',
      flexWrap: 'wrap',
      '& > div': {
        margin: '0 5px',
      },
    },
    button: {
      width: '100%',
      height: '34px',
      textTransform: 'none',
    },
    materialIcon: {
      margin: '10px 3px 0',
      fontSize: 20,
      '&:hover': {
        cursor: 'pointer',
      },
    },
    inputWrapper: {
      display: 'flex',
      flexDirection: 'column',
      '& > div': {
        fontSize: '0.8125rem',
        color: '#013261',
        height: '32px',
      },
      '& label': {
        transform: 'translate(0, 3px) scale(0.75)',
        color: 'rgba(0, 0, 0, 0.54)',
        transformOrigin: 'top left',
        marginTop: '-3px',
      },
      '& fieldset': { border: 'none' },
      '& input': {
        padding: '6px 0 7px',
        fontSize: '0.8125rem',
        color: '#013261',
      },
    },
  });

interface TruckCompanyProps {
  classes: any;
  handleChange: (type: string, event: any) => void;
  handleTruckingCompany: () => void;
  truckerInfo: TruckingCompany;
  closeDialog: (boxType: string) => void;
}

const truckCompany = (props:TruckCompanyProps) => {
  const { classes } = props;


  return (
    <React.Fragment>
      <Dialog
        fullWidth={true}
        maxWidth={'sm'}
        open={true}
        aria-labelledby="max-width-dialog-title"
      >
        <div className={ RfsStyles.newTCWrapper }>
        <DialogTitle>
          <div className={ RfsStyles.attachmentsHeader }>
            <div className={ RfsStyles.attachmentsHeaderText }>Add New Trucking Company</div>
            <div className={ RfsStyles.attachmentsButton } onClick={(events) => props.closeDialog("TcModal")} >
              <IconButton aria-label="Close">
                <Close color='primary' />
              </IconButton> 
            </div>
          </div>
        </DialogTitle>

          <div className={ RfsStyles.attachmentsBody } >
            <div className={ `${ commonStyles.wrapper } ${ commonStyles.mb0 } ${ commonStyles.mt2 }` }>
              <div className={ [classes.dialogInputWrapper, RfsStyles.inputAlign].join(' ')} style={{ width: '100%' }}>
                
                <div className={ [commonStyles.inputLabelWrapper, RfsStyles.inputAlign].join(' ')} style={{ width: '100%' }}>
                  <label className={ commonStyles.inputLabel }>Name Of Trucking Company</label>
                  <TextField
                    id="drop-off-point-name"
                    label=""
                    value={ props.truckerInfo.name }
                    onChange={ (event) => props.handleChange('truckerName', event) }
                    variant="outlined"
                  />
                </div>
                <div className={ [commonStyles.inputLabelWrapper, RfsStyles.inputAlign].join(' ')} style={{ width: '100%' }}>
                  <label className={ commonStyles.inputLabel }>Contact e-Mail Address</label>
                  <TextField
                    id="drop-off-point-address1"
                    label=""
                    value={ props.truckerInfo.email }
                    onChange={ (event) => props.handleChange('truckerEmail', event) }
                    variant="outlined"
                  />
                </div>

              </div>
              <div className={ RfsStyles.newTCbtn }>
                <Button  
                  color="primary" 
                  variant="contained"
                  onClick={(events) => props.handleTruckingCompany() }
                  className={ classes.button } 
                >
                  Add Trucking Company
                </Button>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default withStyles(styles)(truckCompany);
